import React, { Children } from 'react';
import { motion } from 'framer-motion';
const tomes = [{
  color: '#22C55E',
  label: 'El Despertar Motor'
}, {
  color: '#3B82F6',
  label: 'El ADN Técnico'
}, {
  color: '#F97316',
  label: 'El Juego Inteligente'
}, {
  color: '#8B5CF6',
  label: 'La Especialización'
}, {
  color: '#EF4444',
  label: 'Rendimiento y Competición'
}, {
  color: '#14B8A6',
  label: 'La Caja de Herramientas'
}];
const features = ['Por etapa de desarrollo', 'Sesiones listas minuto a minuto', 'Evaluación + planillas por edad', 'Gestión de padres + negocio'];
const stats = [{
  value: '+200',
  label: 'páginas'
}, {
  value: '204',
  label: 'sesiones'
}, {
  value: '40+',
  label: 'ejercicios'
}, {
  value: '25+',
  label: 'plantillas'
}];
export function SolutionSection() {
  return <section className="w-full bg-black py-16 sm:py-24 px-4 pt-[20px] pb-[20px]" data-id="element-280">
      <div className="max-w-3xl mx-auto text-center" data-id="element-281">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.4
      }} className="inline-flex items-center gap-2 border border-[#22C55E]/40 text-[#22C55E] font-semibold text-xs sm:text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-282">
          🏆 El Sistema N°1 para Entrenadores de Fútbol Formativo en el Mundo
          Hispanohablante
        </motion.div>

        {/* Title block */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mb-10" data-id="element-283">
          {/* Brand name with decorative lines */}
          <div className="flex items-center justify-center gap-4 mb-3" data-id="element-284">
            <div className="h-px flex-1 max-w-[60px] bg-gradient-to-r from-transparent to-[#22C55E]/30" data-id="element-285" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white" data-id="element-286">
              ⚽ EDULABS™
            </h2>
            <div className="h-px flex-1 max-w-[60px] bg-gradient-to-l from-transparent to-[#22C55E]/30" data-id="element-287" />
          </div>

          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#22C55E] mb-6 tracking-wide" data-id="element-288">
            MEGAPACK FÚTBOL LISTO™
          </h3>

          {/* Key value prop */}
          <div className="bg-white/[0.03] border border-white/[0.06] rounded-xl px-5 py-4 max-w-lg mx-auto mb-5" data-id="element-289">
            <p className="text-white text-base sm:text-lg font-bold leading-snug mb-2" data-id="element-290">
              6 Tomos + 6 Bonos — Desde U4 hasta U16+ — Todo resuelto.
            </p>
            <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-291">
              {['Sesiones', 'Evaluación', 'Padres', 'Técnica', 'Táctica', 'Negocio'].map(tag => <span key={tag} className="text-gray-400 text-[11px] sm:text-xs font-medium bg-white/[0.04] px-2.5 py-1 rounded-md" data-id="element-292">
                  {tag}
                </span>)}
            </div>
          </div>

          {/* Funciona desde hoy callout */}
          <p className="text-[#22C55E] font-black text-sm sm:text-base tracking-wide" data-id="element-293">
            ⚡ Funciona desde el primer entrenamiento
          </p>
        </motion.div>

        {/* Stats row */}
        <motion.div className="grid grid-cols-4 gap-3 max-w-md mx-auto mb-12" initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} data-id="element-294">
          {stats.map((stat, i) => <div key={i} className="text-center" data-id="element-295">
              <p className="text-[#22C55E] text-2xl sm:text-3xl font-black leading-none mb-1" data-id="element-296">
                {stat.value}
              </p>
              <p className="text-gray-500 text-[10px] sm:text-xs font-medium uppercase tracking-wider" data-id="element-297">
                {stat.label}
              </p>
            </div>)}
        </motion.div>

        {/* Tomes grid */}
        <div className="relative mx-auto mb-14 max-w-lg" data-id="element-298">
          <motion.div className="grid grid-cols-3 sm:grid-cols-6 gap-2.5 sm:gap-3" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.08
            }
          }
        }} data-id="element-299">
            {tomes.map((tome, i) => <motion.div key={i} variants={{
            hidden: {
              opacity: 0,
              y: 20,
              scale: 0.9
            },
            visible: {
              opacity: 1,
              y: 0,
              scale: 1,
              transition: {
                duration: 0.4,
                ease: 'easeOut'
              }
            }
          }} className="aspect-[3/4] rounded-xl shadow-2xl flex items-end justify-center pb-3 px-1.5 relative overflow-hidden group cursor-default" style={{
            backgroundColor: tome.color,
            border: '2px solid rgba(34,197,94,0.5)'
          }} data-id="element-300">
                {/* Shine overlay */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,0.12) 0%, transparent 50%)'
            }} data-id="element-301" />
                <span className="relative text-white text-[9px] sm:text-[10px] font-bold text-center leading-tight" style={{
              textShadow: '0 1px 4px rgba(0,0,0,0.7)'
            }} data-id="element-302">
                  {tome.label}
                </span>
              </motion.div>)}
          </motion.div>

          {/* Badge below tomes */}
          <motion.div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-[#22C55E] text-black font-black text-[10px] sm:text-xs px-5 py-1.5 rounded-full whitespace-nowrap shadow-lg" initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: 0.5
        }} data-id="element-303">
            6 TOMOS COMPLETOS
          </motion.div>
        </div>

        {/* Feature tags */}
        <motion.div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-w-lg mx-auto" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.3
      }} data-id="element-304">
          {features.map((feat, i) => <span key={i} className="bg-[#22C55E]/8 border border-[#22C55E]/20 text-[#22C55E] text-[11px] sm:text-xs font-semibold px-3 py-2.5 rounded-lg text-center" data-id="element-305">
              ✅ {feat}
            </span>)}
        </motion.div>
      </div>
    </section>;
}